module.exports = "https://www.gc-qa.gnp.com.mx/e61003be4e27963c300650510dce12db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/send_24px.svg
// module id = 1859
// module chunks = 0